import Phaser, { Scene } from 'phaser'
import { SCENE_PARAMETERS } from './../constants/game-constants'
import { seconds2StringFormat } from './../utils/functions'
import {
  ENVIRONMENT_ELEMENTS_UTERO,
  PRODUCTS_ELEMENTS,
} from './../constants/assets-constants'

export default class GameUtero extends Scene {
  constructor() {
    super({
      key: 'utero',
      type: Phaser.AUTO,
      physics: {
        default: 'arcade',
        arcade: {
          debug: false,
          gravity: { x: 0, y: 0 },
        },
      },
    })
  }

  // PREPARE data and default configs
  init(props) {
    this.props = props
    this.data.set('points', 0)
    this.data.set('time', SCENE_PARAMETERS.UTERO.TIME_LIMIT)
  }

  // LOAD assets
  preload() {
    Object.keys(ENVIRONMENT_ELEMENTS_UTERO).map(elementKey => {
      this.load.image(elementKey, ENVIRONMENT_ELEMENTS_UTERO[elementKey])
    })

    Object.keys(PRODUCTS_ELEMENTS).map(elementKey => {
      this.load.image(elementKey, PRODUCTS_ELEMENTS[elementKey])
    })
  }

  // ADD assets
  create() {
    this.addUIElements()
    this.addPersonaje()
    this.addInputPlay()
  }

  // RELOADS data on frames changes
  update() {
    const CURRENT_TIME = this.data.list.time
    this.ui_clock_label.setText(seconds2StringFormat(CURRENT_TIME))
    this.ui_points_label.setText(this.data.list.points)
    if (this.data.list.time < 1) {
      this.scene.stop()
      this.props.endScene({ name: 'utero', points: this.data.list.points })
    }
  }

  addInputPlay() {
    let btnPlay = this.add
      .image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, 'play')
      .setInteractive()
      .setScale(this.props.isMobile ? 0.45 : 1)
    btnPlay.on(
      'pointerdown',
      () => {
        if (sessionStorage.getItem('F_DESAFIO_GAME_MODAL_IS_OPEN') === 'true')
          return
        this.addFoodElements()
        this.addEventTimer()
        this.addEventDraggable()
        this.addEventOverlap()
        btnPlay.destroy()
      },
      this,
    )
  }

  addUIElements() {
    let TIMER_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2,
        Y: 30,
      }
      : {
        X: 140,
        Y: 20,
      }

    const [ui_clock_text, ui_clock_icon, ui_clock_label] = this.addUIElement(
      TIMER_POSITION.X,
      TIMER_POSITION.Y,
      'TIEMPO',
      'u_clock',
      seconds2StringFormat(this.data.list.time),
    )

    this.ui_clock_text = ui_clock_text
    this.ui_clock_icon = ui_clock_icon
    this.ui_clock_label = ui_clock_label

    let POINTS_POSITION = this.props.isMobile
      ? {
        X: this.sys.canvas.width / 2 + 110,
        Y: 30,
      }
      : {
        X: this.sys.canvas.width - 10,
        Y: 20,
      }
    const [ui_points_text, ui_points_icon, ui_points_label] = this.addUIElement(
      POINTS_POSITION.X,
      POINTS_POSITION.Y,
      'PUNTOS',
      'u_star',
      this.data.list.points,
    )

    this.ui_points_text = ui_points_text
    this.ui_points_icon = ui_points_icon
    this.ui_points_label = ui_points_label

    this.e_ui_box = this.add.graphics().fillStyle(0xffffff, 0.51)
    if (this.props.isMobile) {
      this.e_ui_box.fillRect(0, 120, this.sys.canvas.width, 80, 11)
    } else {
      const UI_BOX_WIDTH = this.sys.canvas.width * 0.6
      this.e_ui_box.fillRoundedRect(
        this.sys.canvas.width / 2 - UI_BOX_WIDTH / 2,
        5,
        UI_BOX_WIDTH,
        108,
        11,
      )
    }
  }

  addPersonaje() {
    let periodo_position = this.percentPositions({ X: 20, Y: 95 })
    this.box_periodo = this.add.image(
      periodo_position.X,
      periodo_position.Y,
      this.props.isMobile ? 'periodo_mob' : 'periodo_desk',
    )

    this.setScaleSizeBox(this.box_periodo)

    // ======================

    let ambos_position = this.percentPositions({ X: 50, Y: 95 })
    this.box_ambos = this.add.image(
      ambos_position.X,
      ambos_position.Y,
      this.props.isMobile ? 'ambos_mob' : 'ambos_desk',
    )

    this.setScaleSizeBox(this.box_ambos)

    // ======================

    let fuera_position = this.percentPositions({ X: 80, Y: 95 })
    this.box_fuera = this.add.image(
      fuera_position.X,
      fuera_position.Y,
      this.props.isMobile ? 'fuera_periodo_mob' : 'fuera_periodo_desk',
    )

    this.setScaleSizeBox(this.box_fuera)
  }

  setScaleSizeBox(element) {
    element.setOrigin(0.5, 1)
    element.setScale(this.props.isMobile ? 0.8 : 1)
    element.setSize(
      this.props.isMobile ? 100 : 250,
      this.props.isMobile ? 250 : 300,
    )
  }

  addFoodElements() {
    this.e_group_food = this.add
      .group({
        key: 'group_food',
      })
      .setVisible(false)

    let colliderFoodPosition = {
      X: this.game.config.width + 50,
      Y: this.props.isMobile ? 128 : 10,
    }
    this.colliderFood = this.physics.add
      .image(0, 0, 'empty')
      .setOrigin(0, 0)
      .setPosition(colliderFoodPosition.X, colliderFoodPosition.Y)
      .setSize(10, 104)
      .setVisible(false)

    this.e_timerFoodEvent = this.time.addEvent({
      delay: SCENE_PARAMETERS.UTERO.FOOD_ADD_DELAY,
      callback: () => {
        let foodElement = this.physics.add
          .image(100, colliderFoodPosition.Y, this.randomFood())
          .setOrigin(0.5, 0)
          .setVelocityX(SCENE_PARAMETERS.UTERO.FOOD_VELOCITY)
          .setMask(this.e_ui_box.createGeometryMask())

        if (this.props.isMobile) foodElement.setScale(0.68)

        this.input.setDraggable(foodElement.setInteractive(), true)
        this.e_group_food.add(foodElement)
      },
      callbackScope: this,
      loop: true,
    })
  }

  addEventTimer() {
    this.e_timerEvent = this.time.addEvent({
      delay: 1000,
      callback: this.decrementTimer,
      callbackScope: this,
      loop: true,
    })
  }

  addEventDraggable() {

    let sizesBoxes = {
      w: this.props.isMobile ? 100 : 250,
      h: this.props.isMobile ? 200 : 193,
    }

    this.periodo = this.add
      .zone(
        this.box_periodo.x,
        this.box_periodo.y,
        sizesBoxes.w,
        sizesBoxes.h,
      )
      .setRectangleDropZone(sizesBoxes.w, sizesBoxes.h)
      .setZ(100)
      .setOrigin(0.5, 1)
      .setName('periodo')
      .setScale(this.props.isMobile ? 0.8 : 1)

    this.ambos = this.add
      .zone(
        this.box_ambos.x,
        this.box_ambos.y,
        sizesBoxes.w,
        sizesBoxes.h,
      )
      .setRectangleDropZone(sizesBoxes.w, sizesBoxes.h)
      .setZ(100)
      .setOrigin(0.5, 1)
      .setName('ambos')
      .setScale(this.props.isMobile ? 0.8 : 1)

    this.fuera = this.add
      .zone(
        this.box_fuera.x,
        this.box_fuera.y,
        sizesBoxes.w,
        sizesBoxes.h,
      )
      .setRectangleDropZone(sizesBoxes.w, sizesBoxes.h)
      .setZ(100)
      .setOrigin(0.5, 1)
      .setName('fuera')
      .setScale(this.props.isMobile ? 0.8 : 1)


    this.input.on('dragstart', function(pointer, obj) {
      obj.body.moves = false
      obj.clearMask()
    })

    this.input.on('drag', function(pointer, gameObject, dragX, dragY) {
      gameObject.x = dragX
      gameObject.y = dragY
    })

    this.input.on('dragend', function(pointer, gameObject, dropped) {
      if (!dropped) gameObject.destroy()
    })


    this.input.on(
      'drop',
      function(pointer, element, dropZone) {
        var points = this.add
          .image(
            this.percentPositions({ X: 50 }).X,
            this.percentPositions({ Y: 70 }).Y,
            'plusPoints',
          )
          .setScale(0.8)

        const ITEMS_AMBOS = [
          'i_ambos_1',
          'i_ambos_2',
          'i_ambos_3',
          'i_ambos_4',
          'i_ambos_5',
        ]
        const ITEMS_PERIODO = [
          'i_periodo_1',
          'i_periodo_2',
          'i_periodo_3',
          'i_periodo_4',
          'i_periodo_5',
        ]

        const ITEMS_F_PERIODO = [
          'i_fuera_periodo_1',
          'i_fuera_periodo_2',
          'i_fuera_periodo_3',
          'i_fuera_periodo_4',
          'i_fuera_periodo_5',
        ]
        const ITEMS_F_BONUS = [
          'bonus',
        ]


        console.log(dropZone.name)

        if (
          (ITEMS_AMBOS.includes(element.texture.key) && dropZone.name === 'ambos') ||
          (ITEMS_PERIODO.includes(element.texture.key) && dropZone.name === 'periodo') ||
          (ITEMS_F_PERIODO.includes(element.texture.key) && dropZone.name === 'fuera')
        ) {
          // this.box_periodo.setTexture('personaje_feliz')
          this.input.setDraggable(element.setInteractive(), false)
          this.setPoints(1)
          points.setTexture('plusPoints').setVisible(true)
          points.x = element.x
          points.y = element.y
        } else if (ITEMS_F_BONUS.includes(element.texture.key)) {
          this.input.setDraggable(element.setInteractive(), false)
          this.setPoints(2)
          points.setTexture('bonusPoints').setVisible(true)
          points.x = element.x
          points.y = element.y
        } else {
          // this.box_periodo.setTexture('personaje_triste')
          element.destroy()
          this.setPoints(-1)
          points.setTexture('minusPoints').setVisible(true)
          points.x = element.x
          points.y = element.y
        }

        // setTimeout(() => {
        //   try {
        //     // this.box_periodo.setTexture('personaje')
        //   } catch (error) {
        //     console.log(error)
        //   }
        // }, 500)

        this.add.tween({
          targets: points,
          alpha: { from: 1, to: 0 },
          ease: 'Linear',
          duration: 500,
          repeat: 0, // -1: infinity
          yoyo: false,
        })
        setTimeout(() => {
          try {
            points.destroy()
          } catch (error) {
            console.log(error)
          }
        }, 1000)
      },
      this,
    )
  }

  addEventOverlap() {
    this.physics.add.overlap(
      this.colliderFood,
      this.e_group_food,
      (__collider, __food) => {
        __food.destroy()
      },
    )
  }

  // ########### UTILS FUNCTIONS  ################
  setPoints(operator) {
    let newPoinst =
      this.data.list.points + SCENE_PARAMETERS.UTERO.POINTS_TO_ACTION * operator
    this.data.set('points', newPoinst < 0 ? 0 : newPoinst)
  }

  percentPositions({ X = null, Y = null }) {
    return {
      X: X !== null ? (X * this.game.config.width) / 100 : null,
      Y: Y !== null ? (Y * this.game.config.height) / 100 : null,
    }
  }

  decrementTimer() {
    const currentTime = this.data.list.time
    if (currentTime > 0) {
      this.data.set('time', currentTime - 1)
    } else {
      this.data.set('time', 0)
    }
  }

  randomFood() {
    let ELEMENTS = Object.keys(PRODUCTS_ELEMENTS)
    return ELEMENTS[Math.floor(Math.random() * ELEMENTS.length)]
  }

  formatTime(seconds) {
    var minutes = Math.floor(seconds / 60)
    var partInSeconds = seconds % 60
    minutes = minutes.toString().padStart(2, '0')
    partInSeconds = partInSeconds.toString().padStart(2, '0')
    return `${minutes}:${partInSeconds}`
  }

  addUIElement(
    _X = 0,
    _Y = 0,
    _TEXT = '----',
    _ICON = 'u_clock',
    _INITIAL_VALUE = '-- --',
  ) {
    const ui_text = this.add
      .text(
        this.props.isMobile ? _X : _X,
        this.props.isMobile ? _Y : _Y,
        _TEXT,
        {
          fontFamily: 'BwModelica-Medium',
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '16px' : '22px',
          align: 'center',
        },
      )
      .setOrigin(1, 0)
      .setDepth(5)

    const ui_icon = this.add
      .image(ui_text.x - ui_text.width - 5, ui_text.y, _ICON)
      .setOrigin(1, 0.1)
      .setScale(this.props.isMobile ? 0.7 : 1)
      .setDepth(5)

    const ui_data_label = this.add
      .text(
        this.props.isMobile
          ? _X - ui_text.width / 2 - 10
          : _X - ui_text.width / 2,
        this.props.isMobile ? _Y + 15 : _Y + 25,
        _INITIAL_VALUE,
        {
          fontFamily: 'BwModelica-Bold',
          color: '#FFFFFF',
          fontSize: this.props.isMobile ? '28px' : '35px',
          align: 'center',
        },
      )
      .setOrigin(0.5, 0)
      .setDepth(5)

    return [ui_text, ui_icon, ui_data_label]
  }
}
